import FloatLabelInput from '@src/main/shared/ui/components/input/FloatLabelInput';
import { InputSwitch } from 'primereact/inputswitch';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Form.module.scss';

interface CategoryFormProps {
  values: {
    title?: string;
    description?: string;
    visibleOnApp?: boolean;
    typeTitle?: string;
    typeVisibleOnApp?: boolean;
  };
  handleChange: <K extends keyof CategoryFormProps['values']>(
    field: K,
    value: CategoryFormProps['values'][K],
  ) => void;
  errors?: Record<string, string>;
  isEdit?: boolean;
}

const CategoryForm: FC<CategoryFormProps> = ({ values, handleChange, errors, isEdit }) => {
  const { t } = useTranslation();

  return (
    <form className={styles.grid}>
      <div className={styles.field}>
        <FloatLabelInput
          label={t('parameters.issues.titleField')}
          value={values.title ?? ''}
          onChange={(val) => handleChange('title', val)}
          error={errors?.title}
        />
      </div>

      <div className={styles.field}>
        <FloatLabelInput
          label={t('parameters.issues.categories.description')}
          value={values.description ?? ''}
          onChange={(val) => handleChange('description', val)}
          error={errors?.description}
        />
      </div>

      <div className={styles.field}>
        <InputSwitch
          checked={values.visibleOnApp ?? false}
          onChange={(e) => handleChange('visibleOnApp', e.value)}
        />
      </div>

      {!isEdit && (
        <div>
          <h4>{t('parameters.issues.categories.createAssociatedType')}</h4>
          <div className={styles.box}>
            <div className={styles.field}>
              <FloatLabelInput
                label={t('parameters.issues.titleField')}
                value={values.typeTitle || ''}
                onChange={(val) => handleChange('typeTitle', val)}
                error={errors?.typeTitle}
              />
            </div>

            <div className={styles.field}>
              <InputSwitch
                checked={values.typeVisibleOnApp || false}
                onChange={(e) => handleChange('typeVisibleOnApp', e.value)}
              />
            </div>
          </div>
        </div>
      )}
    </form>
  );
};

export default CategoryForm;
